import React from 'react';

const Pending = () => {
  return (
    <div className="container mt-5">
      <div className="alert alert-info">
        Ihr Benutzer wird zurzeit durch einen Admin geprüft und anschließend freigegeben.
        Sie werden via E-Mail darüber informiert, sobald der Benutzer freigegeben wurde.
      </div>
    </div>
  );
};

export default Pending;
